import './EmptySearch.css'

const EmptySearch = () => {
    return (
        <div className='empty-search'>
            Поиск не дал результатов :(
        </div>
    )
}

export default EmptySearch;